(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pradipatva-holiday-notice"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pradipatva-holiday-notice')) {
    customElements.define('pradipatva-holiday-notice', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const dialog = this.querySelector('dialog');
        const starts = Date.parse(this.dataset.starts);
        const expires = Date.parse(this.dataset.expires);
        const inWindow = () => Number.isFinite(starts) && Number.isFinite(expires) && Date.now() >= starts && Date.now() < expires;
        const key = 'pradipatva-holiday-2026-nov7-15-seen';
        if (!dialog || typeof dialog.showModal !== 'function' || !inWindow()) return;
        try { if (sessionStorage.getItem(key)) return; } catch (_) {}
        this.querySelectorAll('[data-holiday-close]').forEach(button => button.addEventListener('click', () => dialog.close()));
        dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('pp-holiday-open');
          window.clearTimeout(this.expiryTimer);
        });
        dialog.addEventListener('click', event => {
          if (event.target !== dialog) return;
          const bounds = dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
        });
        this.checkWindow = () => {
          if (!inWindow()) {
            window.clearTimeout(this.openTimer);
            if (dialog.open) dialog.close();
          }
        };
        document.addEventListener('visibilitychange', this.checkWindow);
        window.addEventListener('pageshow', this.checkWindow);
        window.addEventListener('focus', this.checkWindow);
        const openNotice = () => {
          if (this.isConnected === false || Date.now() >= expires) return;
          if (document.querySelector('dialog[open], html.pr3dg-early')) {
            this.openTimer = window.setTimeout(openNotice, 1000);
            return;
          }
          dialog.showModal();
          document.documentElement.classList.add('pp-holiday-open');
          try { sessionStorage.setItem(key, '1'); } catch (_) {}
          this.expiryTimer = window.setTimeout(() => dialog.close(), Math.min(expires - Date.now(), 2147483647));
        };
        this.openTimer = window.setTimeout(openNotice, 900);
      }
      disconnectedCallback() {
        document.removeEventListener('visibilitychange', this.checkWindow);
        window.removeEventListener('pageshow', this.checkWindow);
        window.removeEventListener('focus', this.checkWindow);
        window.clearTimeout(this.openTimer);
        window.clearTimeout(this.expiryTimer);
        document.documentElement.classList.remove('pp-holiday-open');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
